import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {BarcodeScannerComponent} from '../barcode-scanner/barcode-scanner.component';
import {RestDataService} from '../../../services/rest-data.service';
import {StateStorageService} from '../../../services/state-storage.service';
import {NavController} from '@ionic/angular';

@Component({
    selector: 'app-combined-inventory-input',
    templateUrl: './combined-inventory-input.component.html',
    styleUrls: ['./combined-inventory-input.component.scss'],
})
export class CombinedInventoryInputComponent implements OnInit {

    @Input() inGrid = false;
    @Input() labelSize = 3;
    @Input() labelScanner = '';
    @Input() labelInput = '';
    @Input() invnr = '';
    @ViewChild(BarcodeScannerComponent) barcodeScannerComponent!: BarcodeScannerComponent;

    private initInvnr: string = '';
    private lastInvnr: string = '';

    constructor(private navController: NavController,
                private appState: StateStorageService,
                private dataService: RestDataService) {
    }

    ngOnInit() {
        if (this.invnr === '') this.invnr = this.appState.invnrInput;
        this.initInvnr = (' ' + this.invnr).slice(1); // store copy
        this.appState.invnrInput$
            .subscribe((invNr: string) => {
                this.initInvnr = invNr;
                this.invnr = invNr;
            })
    }

    ionViewWillLeave(): void {
        if (this.barcodeScannerComponent) this.barcodeScannerComponent.doStop();
    }

    input() {
        if (this.barcodeScannerComponent) this.barcodeScannerComponent.doStop();
    }

    onReady(value: string) {
        if (!value) return;
        if (this.initInvnr === value) { // avoid initial self emit
            this.initInvnr = '';
            return;
        }
        if (value !== this.lastInvnr) {
            this.lastInvnr = (' ' + value).slice(1); // store copy
            this.invnr = value;
            this.appState.invnrInput = value;
            if ('' < value) {
                this.navController.navigateRoot('/deviceSingle', {queryParams: {invnr: value}});
            }
        }
    }

}
